<template>
    <el-drawer
        :title="`修改`"
        :visible.sync="show"
        direction="rtl"
        size="40%"
        :wrapperClosable="false"
        :before-close="close"
    >
        <div class="panel">
            <el-form
                ref="item"
                :model="item"
                :rules="rules"
                label-width="100px"
            >
<!--                <el-form-item label="所属项目" prop="projectId">-->
<!--                    <Select-->
<!--                        :url="`/pbl/selectData/project`"-->
<!--                        :value="item.projectId"-->
<!--                        @optionChanged="this.optionChanged"-->
<!--                    ></Select>-->
<!--                </el-form-item>-->
                <el-form-item label="任务内容" prop="content">
                    <el-input
                        type="textarea"
                        v-model="item.content"
                        maxlength="200"
                        show-word-limit
                        :rows="4"
                    ></el-input>
                </el-form-item>
            </el-form>
        </div>
        <span class="fx fx-center">
            <el-button type="primary" @click="doUpdate()">确定</el-button>
            <el-button @click="close()">取消</el-button>
        </span>
    </el-drawer>
</template>

<style scoped></style>

<script>
// import Select from "@/components/Select.vue";

export default {
    // components: { Select },
    props: ["itemProp","onClose"],
    data() {
        return {
            show: false,
            item: this.itemProp,
            rules: {
                // projectId: [
                //     {
                //         validator: this.checkEmpty,
                //         message: "请选择",
                //         trigger: "change"
                //     }
                // ],
                content: [
                    { required: true, message: "请填写", trigger: "blur" }
                ]
            }
        };
    },
    methods: {
        // checkEmpty(rule, value, callback) {
        //     if (rule.field === "projectId") {
        //         let val = this.item.projectId || "";
        //         if (val === "") {
        //             return callback(new Error("请选择"));
        //         }
        //         callback();
        //     }
        // },
        close() {
            this.$emit("close");
        },
        doUpdate() {
            this.$refs["item"].validate(valid => {
                if (valid) {
                    this.$ajaxPost(
                        "/pbl/task/institution/update",
                        {
                            task: this.item
                        },
                        data => {
                            if (data && data.success) {
                                this.$showSuccess("操作成功");
                                this.$emit("submit");
                                this.$emit("close");
                            }
                        }
                    );
                } else {
                    return false;
                }
            });
        },
        optionChanged(result) {
            this.item.projectId = result.value;
        }
    },
    mounted() {
        this.show = true;
    },
    created() {}
};
</script>
